import { Stack, Card, Text } from "@mantine/core";
import { ReactComponent as NewsIcon } from "../../../assets/icons/news.svg";
import { ReactComponent as ArrowRightIcon } from "../../../assets/icons/arrow-right.svg";
import { useNavigate } from "react-router-dom";
import CustomCard from "./../../Elements/Card/Card";
import Title from "./../../Elements/Title/Title";
import "./CompanyNews.css";

const CompanyNews: React.FC = () => {
  const navigate = useNavigate();

  const goToNewsPage = () => {
    navigate("/news");
  };

  const newsList = [
    {
      id: 1,
      type: "Social media update",
      content:
        "This is a post on Linkedin by our CEO commenting new AI trends.",
    },
    {
      id: 2,
      type: "Company",
      content:
        "Dear employees, all of your hard work will be awarded with a million euro bonus. EACH.",
    },
    {
      id: 3,
      type: "Company",
      content:
        "With Fjord Tours you can explore more of the magical fjord landscapes with tours and activities on and around the fjords of Norway",
    },
    {
      id: 4,
      type: "Company",
      content:
        "With Fjord Tours you can explore more of the magical fjord landscapes with tours and activities on and around the fjords of Norway",
    },
  ];

  return (
    <Stack className="w-full" gap="0.5rem">
      <div className="text-[#9e9e9f] gap-2 flex text-base font-bold uppercase items-center">
        <NewsIcon className="inline" />
        <span>Company News</span>
      </div>
      <CustomCard withBorder className="!cursor-default">
        {newsList.map((news) => (
          <Card.Section
            key={news.id}
            className="p-4 border-b !border-[#2f2f31]"
          >
            <Title title={news.type} />
            <Text size="sm" className="!text-neutral-50 !text-sm font-medium">
              {news.content}
            </Text>
          </Card.Section>
        ))}
        <Card.Section
          className="card-section-button p-4"
          onClick={goToNewsPage}
        >
          <span className="text-white text-base font-bold uppercase">
            All news
          </span>
          <ArrowRightIcon />
        </Card.Section>
      </CustomCard>
    </Stack>
  );
};

export default CompanyNews;
